export default __webpack_public_path__ + "static/media/img-0604-liechtenstein-full-face.f0bfd66c.png";